import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';
import { Divider } from '@eb/eds-divider';
import {
    MOVE_TO_NEXT,
    MOVE_TO_PREV,
    MOVE_TO_FIRST,
    MOVE_TO_LAST,
} from '@eb/eds-hot-keys';
import { ACTION_KEY_MAP } from '../hotKeys';
import '../tabs.scss';

class HotTabs extends PureComponent {
    static propTypes = {
        /**
         * List of TabItems with a currently focused tab derived from a focus position
         */
        tabItems: PropTypes.arrayOf(PropTypes.node).isRequired,
        /**
         * Callback that handles the changing of focus on a tab
         */
        onChangeTab: PropTypes.func.isRequired,
    };

    hotKeyHandlers = {
        [MOVE_TO_NEXT]: (e) => this.props.onChangeTab(e, MOVE_TO_NEXT),
        [MOVE_TO_PREV]: (e) => this.props.onChangeTab(e, MOVE_TO_PREV),
        [MOVE_TO_FIRST]: (e) => this.props.onChangeTab(e, MOVE_TO_FIRST),
        [MOVE_TO_LAST]: (e) => this.props.onChangeTab(e, MOVE_TO_LAST),
    };

    render() {
        const { tabItems } = this.props;

        return (
            <HotKeys keyMap={ACTION_KEY_MAP} handlers={this.hotKeyHandlers}>
                <ul
                    className="eds-tabs__navigation eds-l-pad-vert-3 eds-l-mar-bot-3"
                    role="tablist"
                >
                    {tabItems}
                    <Divider />
                </ul>
            </HotKeys>
        );
    }
}

export default HotTabs;
